<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="10">
            <mtc-form-item label="label.taskName">
              <a-input :placeholder="$t('label.pleaseChooseTaskName')" v-model="queryParam.jobClassName"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <mtc-form-item label="label.taskStatus">
              <a-select style="width: 220px" v-model="queryParam.status" :placeholder="$t('label.pleaseSelectStatus')">
                <a-select-option value="">{{$t('label.all')}}</a-select-option>
                <a-select-option value="0">{{$t('label.normal')}}</a-select-option>
                <a-select-option value="-1">{{$t('label.stop')}}</a-select-option>
              </a-select>
            </mtc-form-item>
          </a-col>

          <a-col :md="6" :sm="10" >
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <!--<a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>-->
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>-->
              <mtc-button @click="searchQuery" type="primary" icon="search"  text="button.search"></mtc-button>
              <mtc-button @click="searchReset" type="primary" icon="reload"  style="margin-left: 8px" text="button.reset"></mtc-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <mtc-button @click="handleAdd" type="primary" icon="plus"  text="button.add"></mtc-button>

      <!--<a-button type="primary" icon="download" @click="handleExportXls('定时任务信息')">{{$t('button.export')}}</a-button>-->
      <mtc-button @click="handleExportXls('定时任务信息')" type="primary" icon="download"  text="button.export"></mtc-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <!--<a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
        <mtc-button type="primary" icon="import"  text="button.import"></mtc-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
          <!--<mtc-button   @click="batchDel" style="margin-left: 8px" text="button.delete"></mtc-button>-->
        </a-menu>
        <!--<a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>-->
        <mtc-button    style="margin-left: 8px" text="button.batchOperation"></mtc-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template v-for="(item, index) in columns" :slot="item.slotName">
          <!--<span :key="index">{{ $t(item.slotName) }}</span>-->
          <mtcHeader :key="index" :text="item.slotName" />
        </template>

        <!-- 字符串超长截取省略号显示-->
        <span slot="description" slot-scope="text">
          <j-ellipsis :value="text" :length="20" />
        </span>
        <span slot="parameterRender" slot-scope="text">
          <j-ellipsis :value="text" :length="20" />
        </span>


        <span slot="action" slot-scope="text, record">
          <a @click="resumeJob(record)" v-if="record.status==-1">{{$t('label.start')}}</a>
          <a @click="pauseJob(record)" v-if="record.status==0">{{$t('label.stop')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <!--<a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>-->
            <mtc-button  type="link" size="small" text="button.more"></mtc-button>
            <a-menu slot="overlay">
              <!--<a-menu-item><a @click="executeImmediately(record)">立即执行</a></a-menu-item>-->
              <a-menu-item>

                    <mtc-button @click="executeImmediately(record)" type="link" size="small" text="button.executeImmediately"></mtc-button>

              </a-menu-item>
              <!--<a-menu-item><a @click="handleEdit(record)">{{$t('button.edit')}}</a></a-menu-item>-->
              <a-menu-item>

                   <mtc-button @click="handleEdit(record)" type="link" size="small" text="button.edit"></mtc-button>

              </a-menu-item>

              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <!--<a>{{$t('button.delete')}}</a>-->
                  <mtc-button type="link" size="small" text="button.delete"></mtc-button>
                </a-popconfirm>
              </a-menu-item>

            </a-menu>
          </a-dropdown>
        </span>

        <!-- 状态渲染模板 -->
        <template slot="customRenderStatus" slot-scope="status">
          <a-tag v-if="status==0" color="green">{{$t('label.started')}}</a-tag>
          <a-tag v-if="status==-1" color="orange">{{$t('label.paused')}}</a-tag>
        </template>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <quartzJob-modal ref="modalForm" @ok="modalFormOk"></quartzJob-modal>
  </a-card>
</template>

<script>
  import QuartzJobModal from './modules/QuartzJobModal'
  import { getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JEllipsis from "@/components/jeecg/JEllipsis";
  import { MTC_AUTH } from '@api/servers'

  export default {
    name: "QuartzJobList",
    mixins:[JeecgListMixin],
    components: {
      QuartzJobModal,
      JEllipsis
    },
    data () {
      return {
        description: '定时任务在线管理',
        // 查询条件
        queryParam: {},
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            slotName: 'label.taskName',
            // title: '任务类名',
            align:"center",
            dataIndex: 'jobClassName',
            sorter: true,
            scopedSlots: { title: 'label.taskName'}
/*            customRender:function (text) {
              return "*"+text.substring(9,text.length);
            }*/
          },
          {
            slotName: 'label.cronExpression',
            // title: 'cron表达式',
            align:"center",
            dataIndex: 'cronExpression',
            scopedSlots: { title: 'label.cronExpression'}
          },
          {
            slotName: 'label.args',
            // title: '参数',
            align:"center",
            width: 150,
            dataIndex: 'parameter',
            scopedSlots: {title: 'label.args'},
          },
          {
            slotName: 'label.description',
            // title: '描述',
            align:"center",
            width: 250,
            dataIndex: 'description',
            scopedSlots: {title: 'label.description'},
          },
          {
            slotName: 'label.status',
            // title: '状态',
            align:"center",
            dataIndex: 'status',
            filterMultiple: false,
            // filters: [
            //   { text: '已启动', value: '0' },
            //   { text: '已暂停', value: '-1' },
            // ]
            scopedSlots: {customRender: 'customRenderStatus', title: 'label.status'},
          },
          {
            slotName: 'tableHeader.operation',
            // title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action', title: 'tableHeader.operation'},
            align: "center",
            width: 170
          },
        ],
		url: {
          list: `${MTC_AUTH}sys/quartzJob/list`,
          delete: `${MTC_AUTH}sys/quartzJob/delete`,
          deleteBatch: "/sys/quartzJob/deleteBatch",
          pause: `${MTC_AUTH}sys/quartzJob/pause`,
          resume: `${MTC_AUTH}sys/quartzJob/resume`,
          exportXlsUrl: `${MTC_AUTH}sys/quartzJob/exportXls`,
          importExcelUrl: `${MTC_AUTH}sys/quartzJob/importExcel`,
          execute: `${MTC_AUTH}sys/quartzJob/execute`,
        },
      }
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },

    methods: {

      //筛选需要重写handleTableChange
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        //这种筛选方式只支持单选
        this.filters.status = filters.status[0];
        this.ipagination = pagination;
        this.loadData();
      },
      pauseJob: function(record){
        var that = this;
        //暂停定时任务
        this.$confirm({
          title:"确认暂停",
          content:"是否暂停选中任务?",
          onOk: function(){
            getAction(that.url.pause,{jobClassName:record.jobClassName}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });

      },
      resumeJob: function(record){
        var that = this;
        //恢复定时任务
        this.$confirm({
          title:"确认启动",
          content:"是否启动选中任务?",
          onOk: function(){
            getAction(that.url.resume,{jobClassName:record.jobClassName}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      executeImmediately(record){
        var that = this;
        //立即执行定时任务
        this.$confirm({
          title:"确认提示",
          content:"是否立即执行任务?",
          onOk: function(){
            getAction(that.url.execute,{id:record.id}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>